var common = require("../../utiles/common.js");
var service = require("../../utiles/service");
var layUtils = require("../../utiles/layUtils");
var judge = require("../../utiles/judge.js");
var message = require("../../utiles/message");
var i18n = require("../../_i18n");

module.exports = {
  register: function () {
    document.createElement("user-info");
    ko.components.register("user-info", {
      viewModel: function (params) {
        var $this = this;
        $this.data = ko.observable("");
        $this.userInfo = ko.observable();
        $this.userInfo(common.fetch("/auth/personSubject/loginPerson").data);
        console.log($this.userInfo());
        $this.isenable = ko.observable("");
        $this.lastLoginDate = common.timestampToTime(
          $this.userInfo().loginDate
        );
        
        $this.getEffective = function () {
          var individualData = $this.userInfo().individualData;
          var expireDate = "";
          var activeDate = "";
          if (individualData && individualData.activeDate) {
            activeDate = common.timestampToTime(individualData.activeDate);
          }
          if (individualData && individualData.expireDate) {
            expireDate = common.timestampToTime(individualData.expireDate);
          }
          if (activeDate && expireDate) {
            return activeDate + "-" + expireDate;
          } else if (activeDate) {
            return _i18n("从") + activeDate + _i18n("开始");
          } else if (expireDate) {
            return _i18n("到") + expireDate + _i18n("结束");
          } else {
            return _i18n("未设置生效日期");
          }
        };
        
        $this.close = function () {
          common.redirectTo("/#/appList");
        };
        $this.formData = {
          fields: [
            {
              display: _i18n("手机号"),
              fieldName: "phone",
              rules: ["required", "phone"],
            },
            {
              display: _i18n("邮箱"),
              fieldName: "email",
              rules: ["required", "email"],
            },
          ],
          data: $this.userInfo()
            ? {
              phone: $this.userInfo().individualData.phone,
              email: $this.userInfo().individualData.email,
            }
            : null,
          submitText: _i18n("修改"),
          callback: function (data, callBack) {
            console.log(data);
            common.fetch("/auth/personSubject/updatePerson", {
              type: "POST",
              data: JSON.stringify(data),
              success: function (result) {
                console.log(result);
                layUtils.msg(_i18n("修改成功"));
                callBack();
                $this.userInfo(
                  common.fetch("/auth/personSubject/loginPerson").data
                );
              },
              error: function (data) {
                if (judge.isJSON(data.responseText)) {
                  if (
                    JSON.parse(data.responseText).errorCode ===
                    "TENANT-OR-DOMAIN-ERROR"
                  ) {
                    window.location.href = "/#/tenantError";
                    return false;
                  }
                  message.errorAlert(JSON.parse(data.responseText).message);
                }
                callBack();
              },
            });
          },
        };
        
        
        $this.socialAccounts = function () {
          layUtils.table({
            elem: "#socialAccounts",
            height: 'auto',
            url: "/auth/personSubject/loginPersonSocialAccount",
            method: "post",
            page: false,
            cols: [
              [
                {
                  field: "accountType",
                  title: i18n._i18n("账号类型"),
                  width: '30%',
                  templet: function (e) {
                    return (e.accountType ? e.accountType : e.accontType);
                  },
                },
                {
                  field: "displayName",
                  title: i18n._i18n("认证源名称"),
                  templet: function (e) {
                    return e.displayName;
                  },
                },
                
                {
                  field: "id",
                  title: i18n._i18n("操作"),
                  width: '16%',
                  templet: function (e) {
                    return '<a data-id="' + e.id + '" lay-event="detail">解绑</a>';
                  },
                },
              ],
            ],
          });
          layui.use(["table"], function () {
            // 自动化加载
            var table = layui.table;
            table.on("tool(socialAccounts1)", function (data) {
              console.log(data);
              var checkedText = data.data.id
                ? "是否解除当前账号绑定?"
                : "账号已经解除绑定";
              layer.confirm(checkedText, {offset: "200px", title: "账号解绑提示"}, function () {
                common.fetch("/auth/personSubject/deleteSocialAccount", {
                  type: "post",
                  query: {id: data.data.id},
                  success: function (result) {
                    console.log(result);
                    parent.layer.closeAll();
                    $this.socialAccounts();
                  },
                  
                  error: function (result) {
                    parent.layer.closeAll();
                    $this.socialAccounts();
                  }
                });
              });
            });
          });
        };
        $this.socialAccounts();
      },
      template: require("./UserInfo.html"),
    });
  },
};



//////////////////
// WEBPACK FOOTER
// ./src/component/userInfo/UserInfo.js
// module id = 164
// module chunks = 0